import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Landpage from './pages/landpage/landpage';
import About from './pages/about/about';
import ContactPage from './pages/contact/contact';
import Services from './pages/services/services';
import Career from './pages/career/career';
import Application from './pages/career/application';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Landpage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/career" element={<Career />} />
          <Route path="/career/application" element={<Application />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
